//	L I B S

import { type___iframe___configParams, type___configParams___standards } from '../types/types.iframe';

//	T Y P E S

import { type___geo___lngLat } from '../types/types.types';

//	E X P O R T

export class service_Router {

//#region 																							P A R A M S   P A R S E

	public params___parse(___props: any) : type___iframe___configParams {
		const ___params_unparsed = window.location;
		if (___params_unparsed) {

			const ___params: Record<string, string> | any = new URLSearchParams(___params_unparsed.search);

			const ___param___map_center: string | null = ___params.get('map_center');
			const ___param___map_center___parsed: type___geo___lngLat = (___param___map_center !== null) ? [parseFloat(___param___map_center.split(',')[0]), parseFloat(___param___map_center.split(',')[1])] : null;
			
			const ___param___map_zoom: string | null = ___params.get('map_zoom');
			const ___param___map_zoom___parsed: number = (___param___map_zoom && parseFloat(___param___map_zoom)) ? parseFloat(___param___map_zoom) : type___configParams___standards.map_zoom;

			const ___param___display_user_position: string | null = ___params.get('display_user_position');
			const ___param___display_user_position___parsed: boolean = (___param___display_user_position === 'true') ? true : false;

			const ___param___locale: string | null = ___params.get('locale');
		
			const ___param___from_user: string | null = ___params.get('from_user');

			const ___param___target: string | null = ___params.get('target');
			const ___param___target___parsed: string | null = (___param___target !== null) ? ___param___target as type___iframe___configParams['target'] : 'all';

			const ___param___params: string | null = ___params.get('params')
			const ___param___params___parsed: string[] | null = (() => {
				if (___param___params && ___param___params.includes(',')) {
					return ___param___params.split(',');
				} else if (___param___params !== null) {
					return [___param___params];
				} else { return null; }
			})();

			const ___configParams___parsed: type___iframe___configParams = {
				map_center: ___param___map_center___parsed,
				map_zoom: ___param___map_zoom___parsed,
				locale: ___param___locale as type___iframe___configParams['locale'], 
				display_user_position: ___param___display_user_position___parsed,
				target: (___param___target___parsed && ___param___params___parsed) ? ___param___target___parsed as type___iframe___configParams['target'] : 'all',
				params: (___param___target___parsed && ___param___params___parsed) ? ___param___params___parsed : null,
				from: ___param___from_user,
			};

			return ___configParams___parsed as type___iframe___configParams;

		} else { 
			return type___configParams___standards; 
		}
	}

//#endregion

}